const products = {
  // searchProduct: (number) => `api/get-all-products/${number}`,
  searchProduct: (number) => `api/get-all-marketplaces/${number}`,
  getProductById: (id) => `api/products/${id}`,
};

export default products;
